import * as logger from 'loglevel'

logger.setDefaultLevel(
  process.env.NODE_ENV === 'production'
    ? logger.levels.ERROR
    : logger.levels.DEBUG
)

export default logger
